<template>

  <div class="componente-completo" ref="containerRef">
    <img ref="bolaRef" src="@/assets/bola.avif" alt="Bola de disco" class="bola-disco" />
    <img ref="estrellasRef" src="@/assets/estrellas.png" alt="Estrellas" class="estrellas-decorativas" />
    <img ref="fotoRef" src="@/assets/ovalada1.webp" alt="Foto destacada" class="foto-elegante" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'ComponenteCompleto',
  setup() {
    const containerRef = ref(null);
    const fotoRef = ref(null);
    const foto2Ref = ref(null);
    const bolaRef = ref(null);
    const estrellasRef = ref(null);
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);

    const animate = () => {
      const pathLength = wavePathStroke.value.getTotalLength();
      wavePathStroke.value.style.strokeDasharray = pathLength;
      wavePathStroke.value.style.strokeDashoffset = pathLength;

      const tl = gsap.timeline();

      tl.fromTo(waveSvg.value, { opacity: 0, y: -60 }, { opacity: 1, y: 0, duration: 1 })
        .to(wavePathStroke.value, { strokeDashoffset: 0, duration: 1.4 }, '-=0.6')
        .to(wavePathFill.value, { opacity: 1, duration: 1 }, '-=1')
        .fromTo(containerRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2 }, '-=0.6')
        .fromTo(fotoRef.value, { y: -120, opacity: 0, rotate: -10, scale: 0.9 }, { y: 0, opacity: 1, rotate: -4, scale: 1, duration: 1.2, ease: 'power2.out' }, '-=1')
        .fromTo(foto2Ref.value, { y: -100, opacity: 0, rotate: 10, scale: 0.9 }, { y: 0, opacity: 1, rotate: 4, scale: 1, duration: 1.2, ease: 'power2.out' }, '-=1.1')
        .fromTo(bolaRef.value, { y: -80, scale: 0.7, opacity: 0 }, { y: 0, scale: 1, opacity: 1, duration: 1.1, ease: 'back.out(1.7)' }, '-=1.1')
        .fromTo(estrellasRef.value, { y: -70, opacity: 0, scale: 0.8 }, { y: 0, opacity: 1, scale: 1, duration: 1, ease: 'power2.out' }, '-=1');
    };

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate();
          obs.unobserve(entry.target);
        }
      }, { threshold: 0.3 });

      if (containerRef.value) observer.observe(containerRef.value);
    });

    return {
      containerRef,
      fotoRef,
      foto2Ref,
      bolaRef,
      estrellasRef,
      waveSvg,
      wavePathStroke,
      wavePathFill
    };
  }
};
</script>

<style scoped>
.componente-completo {
  position: relative;
  width: 100%;
  padding: 0px 0 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  margin-top:-20px;
}

.animated-wave {
  width: 100%;
  height: auto;
  pointer-events: none;
  opacity: 0;
}

.wave-path-stroke {
  fill: none;
  stroke: #ffffff00;
  stroke-width: 2.5;
}

.wave-path-fill {
  opacity: 0;
}

.bola-disco {
  width: 120px;
  margin-top: 0;
  transform-origin: center;
  opacity: 0;
  z-index: 1;
  margin-right: -180px;
  margin-bottom: -30px;
}

.estrellas-decorativas {
  width: 100px;
  position: absolute;
  bottom: 30px;
  right: 30px;
  opacity: 0;
  z-index: 0;
}

.foto-elegante,
.foto-elegante-reversa {
  width: 470px;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
  opacity: 0;
  transform-origin: center;
  margin: 30px 0;
}

.foto-elegante {
  transform: rotate(-4deg);
  z-index: 2;
}

.foto-elegante-reversa {
  transform: rotate(4deg);
  z-index: 1;
}
</style>
